module.exports = __webpack_public_path__ + "static/media/gallery-img-10.7951f9f5.jpg";